import React from 'react'
import {
  GridLayout,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  useRemoteParticipants,
  useTracks,
} from '@livekit/components-react'
import '@livekit/components-styles'
import { Track } from 'livekit-client'
import { Box } from '@mui/material'

interface BoothVideoProps {
  livekitUrl: string
  livekitToken: string
  onDisconnected: () => void
}

/**
 * ブースの通話 (映像と音声だけ)。患者は操作しないので、マイク・カメラ・終了の操作は出さない。
 * 終えるのは遠隔の店の「指導を終える」(back log/250)。
 */
export const BoothVideo: React.FC<BoothVideoProps> = ({
  livekitUrl,
  livekitToken,
  onDisconnected,
}) => (
  <Box sx={{ position: 'relative', height: '100vh', bgcolor: '#000' }}>
    <LiveKitRoom
      serverUrl={livekitUrl}
      token={livekitToken}
      connect
      audio
      video
      onDisconnected={onDisconnected}
      data-lk-theme="default"
      style={{ height: '100%' }}
    >
      <BoothGrid />
      <RoomAudioRenderer />
    </LiveKitRoom>
  </Box>
)

const BoothGrid: React.FC = () => {
  const tracks = useTracks(
    [{ source: Track.Source.Camera, withPlaceholder: true }],
    {
      onlySubscribed: false,
    }
  )
  // 薬剤師が通話を抜けても (「あとで」で申し送りを保留・つなぎ直し)、通話は開いたままなので
  // ブースは部屋に残る。相手が居ない間は案内を重ねる
  const pharmacistAway = useRemoteParticipants().length === 0
  return (
    <>
      <GridLayout tracks={tracks} style={{ height: '100%' }}>
        <ParticipantTile />
      </GridLayout>
      {pharmacistAway && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 4,
            bgcolor: 'rgba(0, 0, 0, 0.6)',
            color: '#FFFFFF',
            fontSize: 32,
            textAlign: 'center',
          }}
        >
          薬剤師が席を外しています。そのままお待ちください
        </Box>
      )}
    </>
  )
}
